import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getEducationScore } from "./education";
import { getPersonalDetailsScore } from "./personal-details";
import { getProjectScore } from "./project";
import { getSkillScore } from "./skill";
import { getExperienceScore } from "./work-exerience";


type MaxCoreSectionScore = {
  projectsMaxScore: number;
    experienceMaxScore: number;
    educationMaxScore: number;
    skillsMaxScore: number;
    personalDetailsMaxScore: number;
}

export const getCoreSectionScores = (resume: ResumeAnalysis, maxCoreSectionScore: MaxCoreSectionScore) => {
  const personalDetailsScore = resume.profile ? getPersonalDetailsScore(resume.profile, maxCoreSectionScore.personalDetailsMaxScore).totalScore : 0;
  const educationScore = resume.educations ? getEducationScore(resume.educations, maxCoreSectionScore.educationMaxScore).totalScore : 0;
  const experienceScore = resume.workExperiences ? getExperienceScore(resume.workExperiences, maxCoreSectionScore.experienceMaxScore).totalScore : 0;
  const projectScore = resume.projects ? getProjectScore(resume.projects, maxCoreSectionScore.projectsMaxScore).totalScore : 0;
  const skillsScore = resume.skills ? getSkillScore(resume.skills, maxCoreSectionScore.skillsMaxScore).totalScore : 0;
  // console.log(maxCoreSectionScore)
  return {
    totalScore: personalDetailsScore + educationScore + experienceScore + projectScore + skillsScore,
    personalDetailsScore,
    educationScore,
    experienceScore,
    projectScore,
    skillsScore
  };


}
